// constants
import { showSuccessAlert } from "../../constants/alerts";
import { NewsBnrActionTypes } from "./constants";

const INIT_STATE = {
  newsBanner: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface NewsBannerData {
  id: number;
  banner_text: string;
  file: any;
}

interface NewsBannerActionType {
  type:
    | NewsBnrActionTypes.API_RESPONSE_SUCCESS
    | NewsBnrActionTypes.API_RESPONSE_ERROR
    | NewsBnrActionTypes.CREATE_NEWS_IMAGE
    | NewsBnrActionTypes.GET_NEWS_IMAGE
    | NewsBnrActionTypes.UPDATE_NEWS_IMAGE
    | NewsBnrActionTypes.DELETE_NEWS_IMAGE;
  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
    newsBanner?: [];
  };
}

interface State {
  mainBanner?: NewsBannerData | [];
  loading?: boolean;
  value?: boolean;
}

const NewsBanner = (
  state: any = INIT_STATE,
  action: NewsBannerActionType
): any => {
  switch (action.type) {
    case NewsBnrActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case NewsBnrActionTypes.CREATE_NEWS_IMAGE: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case NewsBnrActionTypes.GET_NEWS_IMAGE: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            newsBanner: action.payload.data,
          };
        }
        case NewsBnrActionTypes.UPDATE_NEWS_IMAGE: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case NewsBnrActionTypes.DELETE_NEWS_IMAGE: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case NewsBnrActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case NewsBnrActionTypes.CREATE_NEWS_IMAGE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case NewsBnrActionTypes.UPDATE_NEWS_IMAGE: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case NewsBnrActionTypes.GET_NEWS_IMAGE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case NewsBnrActionTypes.DELETE_NEWS_IMAGE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case NewsBnrActionTypes.CREATE_NEWS_IMAGE:
      return { ...state, loading: true };
    case NewsBnrActionTypes.UPDATE_NEWS_IMAGE:
      return { ...state, loading: true };
    case NewsBnrActionTypes.GET_NEWS_IMAGE:
      return { ...state, loading: true, initialLoading: true };
    case NewsBnrActionTypes.DELETE_NEWS_IMAGE:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default NewsBanner;
